import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Calendar as DateIcon, Plus as PlusIcon, TextEdit as PlainTextIcon } from "@air/next-icons";
import { Button } from "@air/primitive-button";
import { IconButton } from "@air/primitive-icon-button";
import { useAirModal } from "@air/provider-modal";
import { itemIsSelectedSelector } from "@air/redux-selected-items";
import { memo } from "react";
import { useSelector } from "react-redux";
import { CustomFieldListWithOverflow } from "~/components/CustomFields/CustomFieldListWithOverflow";
import { ASSET_CARD_ADD_CUSTOM_FIELDS, ASSET_CARD_CUSTOM_FIELDS } from "~/constants/testIDs";
import { boardCollectionHasCustomFieldsSelector } from "~/store/boardCollection/selectors";
import { selectedClipsSelector } from "~/store/selectedItems/selectors";
import { getCustomFieldDateValues, getCustomFieldPlainTextValues, getCustomFieldSingleAndMultiSelectValues } from "~/utils/CustomFields";
import { useAirStore } from "~/utils/ReduxUtils";
import { BoardCollectionGalleryAssetDetailsModal } from "./BoardCollectionGalleryAssetDetailsModal";
const TEXT_DATE_ICON_BUTTON_WIDTH = 28;
export const BoardCollectionGalleryAssetCustomFields = /*#__PURE__*/ memo((param)=>{
    let { clip, width } = param;
    var _clip_customFields, _clip_customFields1, _clip_customFields2;
    const store = useAirStore();
    const isSelected = useSelector((st)=>itemIsSelectedSelector(st, clip.id));
    const hasCustomFields = useSelector(boardCollectionHasCustomFieldsSelector);
    const [showBoardCollectionGalleryAssetDetailsModal] = useAirModal(BoardCollectionGalleryAssetDetailsModal);
    const customFieldSingleAndMultiSelectValues = (_clip_customFields = clip.customFields) === null || _clip_customFields === void 0 ? void 0 : _clip_customFields.filter(getCustomFieldSingleAndMultiSelectValues);
    const customFieldPlainTextValues = (_clip_customFields1 = clip.customFields) === null || _clip_customFields1 === void 0 ? void 0 : _clip_customFields1.filter(getCustomFieldPlainTextValues);
    const customFieldDateValues = (_clip_customFields2 = clip.customFields) === null || _clip_customFields2 === void 0 ? void 0 : _clip_customFields2.filter(getCustomFieldDateValues);
    const reducedWidth = (customFieldPlainTextValues && customFieldPlainTextValues.length > 0 ? TEXT_DATE_ICON_BUTTON_WIDTH : 0) - (customFieldDateValues && customFieldDateValues.length > 0 ? TEXT_DATE_ICON_BUTTON_WIDTH : 0);
    const renderTextOrDateIconButton = (values)=>{
        if (!values || values && values.length < 1) return;
        return /*#__PURE__*/ _jsx(IconButton, {
            size: "extra-small",
            appearance: "filled",
            color: "grey",
            className: "mr-1 p-1",
            icon: values.some((param)=>{
                let { plainTextValue } = param;
                return !!plainTextValue;
            }) ? PlainTextIcon : DateIcon,
            onClick: ()=>showBoardCollectionGalleryAssetDetailsModal({
                    clips: isSelected ? selectedClipsSelector(store.getState()) : [
                        clip
                    ]
                }),
            label: "Add details"
        });
    };
    return /*#__PURE__*/ _jsxs("div", {
        className: "mt-2 flex items-center p-0.5",
        children: [
            renderTextOrDateIconButton(customFieldPlainTextValues),
            renderTextOrDateIconButton(customFieldDateValues),
            hasCustomFields && /*#__PURE__*/ _jsx(_Fragment, {
                children: customFieldSingleAndMultiSelectValues && customFieldSingleAndMultiSelectValues.length > 0 ? /*#__PURE__*/ _jsx("div", {
                    className: "grow overflow-x-auto",
                    "data-testid": ASSET_CARD_CUSTOM_FIELDS,
                    children: /*#__PURE__*/ _jsx(CustomFieldListWithOverflow, {
                        className: "mt-0",
                        customFields: customFieldSingleAndMultiSelectValues,
                        allowedWidth: width - reducedWidth,
                        onClick: ()=>showBoardCollectionGalleryAssetDetailsModal({
                                clips: isSelected ? selectedClipsSelector(store.getState()) : [
                                    clip
                                ]
                            })
                    })
                }) : /*#__PURE__*/ _jsx(Button, {
                    prefix: /*#__PURE__*/ _jsx(PlusIcon, {
                        className: "size-4"
                    }),
                    size: "small",
                    className: "w-full justify-start",
                    appearance: "ghost",
                    color: "grey",
                    onClick: ()=>showBoardCollectionGalleryAssetDetailsModal({
                            clips: isSelected ? selectedClipsSelector(store.getState()) : [
                                clip
                            ]
                        }),
                    "data-testid": ASSET_CARD_ADD_CUSTOM_FIELDS,
                    children: "Add details"
                })
            })
        ]
    });
});
BoardCollectionGalleryAssetCustomFields.displayName = "BoardCollectionGalleryAsset";
